import styled from 'styled-components';
import { space, layout, position } from 'styled-system';
import Box from 'elements/Box';

export const Content = styled(Box)(({ theme, hasError }) => `
  ${hasError ? `
    background: linear-gradient(
      to bottom right,
      transparent calc(50% - 1px),
      ${theme.colors.dark},
      transparent calc(50% + 1px)
    );
  ` : ''}
`);
export const Cell = styled.td(({ theme, square, numCols, blank, selected, highlighted, isTarget }) => `
  ${square ?  `
    width: calc(100%/${numCols});
    position: relative;
    &:after {
      content: '';
      display: block;
      margin-top: 100%;
    }
    ${Content} {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  ` : ''}
  ${blank ? `
    background: ${theme.colors.dark};
    color: transparent;
  ` : ''}
  ${highlighted ? `
    background: ${theme.colors.utility.ghost};
  ` : ''}
  ${selected ? `
    background: ${theme.colors.utility.light};
    color: ${theme.colors.white};
  ` : ''}
  ${isTarget ? `
    background: ${theme.colors.utility.secondary};
    color: ${theme.colors.utility.ghost};
  ` : ''}
`, space);

export const Row = styled.tr`

`;
export const Head = styled.thead`

`;
export const Body = styled.tbody`

`;
export const Table = styled.table(({ theme, noSelect }) => `
  border-collapse: collapse;
  ${noSelect ? `user-select: none;` : ''}
  ${Head}, ${Cell} {
    border: 1px solid ${theme.colors.dark};
  }
`, space, layout, position);
